import { render, staticRenderFns } from "./SntPagination.vue?vue&type=template&id=6705b8b2&scoped=true&"
import script from "./SntPagination.vue?vue&type=script&lang=js&"
export * from "./SntPagination.vue?vue&type=script&lang=js&"
import style0 from "./SntPagination.vue?vue&type=style&index=0&id=6705b8b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6705b8b2",
  null
  
)

export default component.exports